import { createFileRoute, notFound } from "@tanstack/react-router";
import WebdesignLandingPage from "@/pages/WebdesignLandingPage";
import NotFound from "@/pages/NotFound";
import { buildRouteHead } from "@/lib/route-head";
import { getHarzCityBySlug } from "@/data/harzCities";
import { serviceSchema, breadcrumbSchema } from "@/lib/schema";

export const Route = createFileRoute("/webdesign/$city")({
  // Ohne echten 404-Status werten Google & Co. unbekannte Städte als Soft-404.
  loader: ({ params }) => {
    if (!getHarzCityBySlug(params.city)) {
      throw notFound();
    }
  },
  notFoundComponent: NotFound,
  head: ({ params }) => {
    const city = getHarzCityBySlug(params.city);
    if (!city) {
      return buildRouteHead({
        title: "Stadt nicht gefunden | Enno & Jens",
        description: "Diese Stadt haben wir nicht im Angebot. Zur Übersicht aller Harzer Städte.",
        path: `/webdesign/${params.city}`,
        noIndex: true,
      });
    }
    return buildRouteHead({
      title: `Webdesign & Webseiten für Unternehmen in ${city.name}`,
      description: `Wir erstellen professionelle Webseiten für Firmen in ${city.name}. Modernes Design, SEO-optimiert, mobile-ready & schnell. Jetzt kostenlos anfragen!`,
      path: `/webdesign/${city.slug}`,
      image: "/images/services/webdesign-1024.webp",
      imageAlt: `Webdesign für ${city.name}`,
      imageWidth: 1024,
      imageHeight: 730,
      scripts: [
        serviceSchema({
          name: `Webdesign für ${city.name}`,
          description: `Professionelle Webseiten & Webdesign für Unternehmen in ${city.name}`,
          path: `/webdesign/${city.slug}`,
          serviceType: "Webdesign & Webseitenerstellung",
        }),
        breadcrumbSchema([
          { name: "Startseite", path: "/" },
          { name: `Webdesign ${city.name}`, path: `/webdesign/${city.slug}` },
        ]),
      ],
    });
  },
  component: WebdesignLandingPage,
});
